import './BtnIndice.css'

function BtnIndice({text}) {
  return (
    <>
      <li >
                       
        <p className='btnIndice'>{text}</p>
                   
        </li>
    </>
  );
}

export default BtnIndice;
